import { API_URLs } from "../../constants/api_urls"
import { ReferralsDataType } from "../../types/referrals/ReferralsTypes";
import axiosClient from "../../utils/axiosClient"

export const fetchReferralsData = async () : Promise<ReferralsDataType> => {
    const response = await axiosClient.get(API_URLs.REFERRALS);
    return response.data;
}